import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomModal from "./CustomModal";
import AuthInput from "../Input/AuthInput";
import AddingLightLoader from "../Loaders/AddingLightLoader";
import { ErrorToast, SuccessToast, WarningToast } from "../../utils/ShowToast";
import { CreateExpenseApi } from "../../ApiRequests";
import AuthBtn from "../Buttons/AuthBtn";
import { fetchExpenses } from "../../store/Slices/ExpenseSlice";
import ExpenseTypeSelector from "../Selector/ExpenseTypeSelector";
import AuthTextArea from "../Input/AuthTextArea";
import PaymentAccountSelector from "../Selector/PaymentAccountSelector";
import { fetchAccounts } from "../../store/Slices/AccountSlice";
import { toLocalYmd } from "../../utils/dateTime";

// Get user data with null checks
const userData = JSON.parse(localStorage.getItem("user")) || {};
const { branchId = "" } = userData;

const AddExpenseModal = ({ Open, setOpen }) => {
  const [amount, setAmount] = useState("");
  const [desc, setDesc] = useState("");
  const [CurDate, setCurDate] = useState(
    toLocalYmd()
  );

  const [selectedType, setSelectedType] = useState("");
  const [selectedAccount, setSelectedAccount] = useState("");

  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const AccountState = useSelector((state) => state.AccountState);

  useEffect(() => {
    if (!Open) return;
    dispatch(fetchAccounts());
  }, [Open, dispatch]);

  useEffect(() => {
    if (!Open || selectedAccount?._id) return;
    const accounts = Array.isArray(AccountState.data) ? AccountState.data : [];
    const cashAccount =
      accounts.find(
        (row) => String(row.account_name || "").toUpperCase() === "CASH"
      ) || accounts[0];
    if (cashAccount) setSelectedAccount(cashAccount);
  }, [Open, selectedAccount, AccountState.data]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    let payload = {
      expenseTypeId: selectedType?._id,
      desc: desc,
      expense: Number(amount),
      date: CurDate,
      branchId,
      accountId: selectedAccount?._id,
    };

    if (!amount || isNaN(amount)) WarningToast("Enter a valid Amount");
    else if (!desc) WarningToast("Enter a valid Description");
    else if (!CurDate) WarningToast("Select a valid Date");
    else if (!selectedAccount?._id) WarningToast("Select account to pay from");
    else if (!selectedType?._id) WarningToast("Select expense type");
    else {
      try {
        let response = await CreateExpenseApi(payload);
        if (response.data.success) {
          setOpen(false);
          SuccessToast("Expense added successfully");
          dispatch(fetchExpenses());
          dispatch(fetchAccounts());
        } else {
          ErrorToast(response.data.error?.msg);
        }
      } catch (err) {
        console.error(err);
        ErrorToast(err.response.data.error.msg);
        ErrorToast("Failed to add Expense");
      }
    }
    setLoading(false);
  };

  return (
    <CustomModal open={Open} setOpen={setOpen}>
      <div className="pb-8">
        <h1 className="w-full text-center font-[700] text-3xl py-8">
          Add Expense
        </h1>
        <div className="flex gap-4 max696:flex-col px-10 max696:max-h-[70vh] max696:overflow-y-auto">
          <div className="flex flex-col gap-y-4">
            <ExpenseTypeSelector
              selectedType={selectedType}
              setSelectedType={setSelectedType}
            />
            <PaymentAccountSelector
              label="Pay from account"
              selectedAccount={selectedAccount}
              setSelectedAccount={setSelectedAccount}
            />
            <AuthTextArea
              label="Description"
              placeholder="Enter Description"
              Value={desc}
              setValue={setDesc}
            />
            <AuthInput
              label="Date"
              placeholder="Select Date"
              Type="date"
              Value={CurDate}
              setValue={setCurDate}
            />

            <AuthInput
              label="Amount"
              placeholder="Enter Amount"
              Type="number"
              Value={amount}
              setValue={setAmount}
            />
          </div>
        </div>
        <div className="flex justify-center items-center gap-x-2 mt-5 px-5">
          {loading ? (
            <AddingLightLoader />
          ) : (
            <>
              <AuthBtn title={"Add Expense"} onSubmit={onSubmit} type={1} />
              <AuthBtn
                title={"Cancel"}
                onSubmit={() => setOpen(false)}
                type={2}
              />
            </>
          )}
        </div>
      </div>
    </CustomModal>
  );
};

export default AddExpenseModal;
